import React, { useEffect, useState } from "react";
import credintial_icon from "../../../assets/icons/credintial_svg_icon.svg";
import metric_icon from "../../../assets/icons/metric_icn.svg";
import analysis_icon from "../../../assets/icons/analysis_icn.svg";
import open_eye from "../../../assets/icons/open_eye.svg";
import close_eye from "../../../assets/icons/hide_eye.svg";

import {
  Box,
  Button,
  FormControlLabel,
  FormGroup,
  Grid,
  Modal,
  Typography,
} from "@mui/material";
import Switch from "@mui/material/Switch";
import styled from "@emotion/styled";

import { dollarUS, formatDate } from "../../../utilities/formatters";
import { addCurrentAccount } from "../../../store/reducers/userProfileReducer";
import {
  ClearAccountDetails,
  CleartraderJournalNew,
  fetchPerformanceChart,
} from "../../../store/reducers/dashboardReducer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const StyleSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      "&.Mui-disabled": {
        color: "#33cf4d",
      },
      transform: "translateX(12px)",
      color: "#33cf4d",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#3A4B64" : "#1890ff",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 0.5,
    backgroundColor:
      theme.palette.mode === "dark" ? "#3A4B64" : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

export const AntSwitch = (props) => (
  <FormGroup>
    <FormControlLabel
      control={
        <StyleSwitch
          checked={props.checked}
          disabled
          inputProps={{ "aria-label": "ant design" }}
          {...props}
        />
      }
      label={
        <span
          style={{
            color: props.checked ? "#37C976" : "#fd504f",
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "130%",
            fontFamily: "Outfit",
            fontStyle: "normal",
          }}
        >
          {props.label}
        </span>
      }
    />
  </FormGroup>
);

const CopyToClipBoard = ({ text }) => {
  const [copied, setCopied] = React.useState(false);

  const onCopyText = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  function updateClipboard(newClip) {
    navigator.clipboard.writeText(newClip).then(
      () => {
        setCopied(true);
        onCopyText();
      },
      () => {
        console.log("Copy unsuccessful");
      }
    );
  }

  return (
    <Button
      variant="text"
      onClick={(e) => {
        updateClipboard(text);
      }}
    >
      {copied ? "Copied!" : "Copy"}
    </Button>
  );
};

const Account = ({ data , theme }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const end_date =
    (data.expiry_date !== null && formatDate(new Date(data.expiry_date))) ||
    "Unlimited";
  const balance_equity = JSON.parse(data.balance_equity);

  // Modal State
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const AccountDetails = [
    { primaryText: data.status, secondaryText: "Account Type" },
    { primaryText: end_date, secondaryText: "End Date" },
    {
      primaryText: dollarUS(balance_equity["balance"]),
      secondaryText: "Balance",
    },
    {
      primaryText: data.is_disqualified === true ? "Failed  " : "Passed",
      secondaryText: "Result",
      styles: {
        background:
          data.is_disqualified === true
            ? "rgba(253, 80, 79, 0.25);"
            : "rgba(12, 206, 107, 0.25);",
      },
    },
  ];
  // Fetching balance-eq chart data

  const user_profile = useSelector((state) => state.user);
  const [CurrentAcc, setCurrentAcc] = useState(user_profile?.current_account);
  useEffect(() => {
    if (Object.keys(user_profile).length) {
      if (user_profile.current_account) {
        setCurrentAcc(user_profile.current_account);
      }
    }
  }, [user_profile]);

  const handleCardClick = (login_id) => {
    dispatch(ClearAccountDetails());
    dispatch(CleartraderJournalNew());
    dispatch(addCurrentAccount(login_id));
  };

  const handleMetricsClick = (data) => {
    dispatch(ClearAccountDetails());
    dispatch(CleartraderJournalNew());
    dispatch(addCurrentAccount(data.login_id));
    navigate("/AccountMetric");
  };
  const handleAnalysisClick = (data) => {
    dispatch(ClearAccountDetails());
    dispatch(CleartraderJournalNew());
    dispatch(addCurrentAccount(data.login_id));
    navigate("/AccountAnalysis");
  };


  return (
    <Grid
      style={{ cursor: "pointer" }}
      container
      className={`account-card ${
        CurrentAcc === data?.login_id && "active-card"
      }`}
      spacing={1}
      onClick={() => handleCardClick(data.login_id)}
    >
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-credintial">
          Account Credentials
          <ul>
            <li>
              <p>LoginID : </p> <span>{data.login_id}</span>
            </li>
            <li>
              <p>Password :</p> <span>{data.password}</span>
            </li>
            <li>
              <p>Platform : </p> <span>{data.platform}</span>
            </li>
            <li>
              <p>Server : </p> <span>{data.server}</span>
            </li>
          </ul>
        </Box>
      </Modal>
      <Grid item container justifyContent="start" alignItems="center" xs={12}>
        <Grid item xs={8}>
          {/* <AntSwitch
            label={data.is_Active ? "Active" : "In Active"}
            checked={data.is_Active}
            inputProps={{ "aria-label": "Account status" }}
          /> */}
          <Typography
            variant="subtitle2"
            component="div"
            sx={{ color: "white", fontSize: "18px" }}
          >
            Account : {data.login_id}
          </Typography>
        </Grid>
        {/* <Grid item xs={6}>
          <Button onClick={handleOpen}>Credentials</Button>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ color: "#FFF" }}
          >
            <Box sx={modalStyle}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Account Credentials
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                Login Id: <b>{data.login_id}</b>{" "}
                <CopyToClipBoard text={data.login_id} />
                <br />
                Password: <b>{data.password}</b>{" "}
                <CopyToClipBoard text={data.password} />
                <br />
                Platform: <b>{data.platform}</b>{" "}
                <CopyToClipBoard text={data.platform} />
                <br />
                Broker: <b>{data.broker}</b>{" "}
                <CopyToClipBoard text={data.broker} />
                <br />
                server: <b>{data.server}</b>{" "}
                <CopyToClipBoard text={data.server} />
              </Typography>
            </Box>
          </Modal>
        </Grid> */}
      </Grid>
      <Grid
        item
        xs={12}
        container
        spacing={2}
        sx={{ display: "flex", flexWrap: "nowrap", flexDirection: "column" }}
        className="account-card-inner"
      >
        {Array.isArray(AccountDetails) &&
          AccountDetails.map((detail, idx) => (
            <Grid
              item
              sx={{
                display: "flex",
                justifyContent: "space-between",
                paddingRight: "18px",
                paddingTop: "10px !important",
              }}
              xs={true}
              key={idx}
            >
              <Typography
                className="acc-detail-label"
                variant="subtitle2"
                component="div"
                // sx={{ fontSize: "16px !important" }}
              >
                {detail.secondaryText}
              </Typography>
              <Typography
                sx={{
                  color: `${
                    detail.secondaryText === "Balance" ? "#0cce6b" : ""
                  }`,
                  background:
                    data.is_disqualified && detail.secondaryText === "Result"
                      ? "rgba(253, 80, 79, 0.25)"
                      : data.is_disqualified === false &&
                        detail.secondaryText === "Result"
                      ? "rgba(12, 206, 107, 0.25)"
                      : "",
                  padding:
                    data.is_disqualified && detail.secondaryText === "Result"
                      ? "5px 8px"
                      : data.is_disqualified === false &&
                        detail.secondaryText === "Result"
                      ? "5px 8px"
                      : "",
                  border:
                    data.is_disqualified && detail.secondaryText === "Result"
                      ? "1px solid #FD504F"
                      : data.is_disqualified === false &&
                        detail.secondaryText === "Result"
                      ? "1px solid #0CCE6B"
                      : "",
                  borderRadius: detail.secondaryText === "Result" ? "6px" : "",
                }}
                className="acc-detail-val"
                variant="subtitle1"
                component="div"
              >
                {detail.primaryText}
              </Typography>
            </Grid>
          ))}
      </Grid>

      <Grid
      className="svg_group"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "30px",
          borderRadius: "8px",
          border: "1px solid var(--primary-p-blue-100-main, #04D9FF)",
          padding: "15px 15px 0px 15px !important",
          marginTop: "10px",
          // paddingRight: "18px",
          // paddingTop: "10px !important",
        }}
        xs={true}
        // key={idx}
      >
        <Typography>
          <Typography
            onClick={handleOpen}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "5px",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <img src={credintial_icon} width="30px" />
            <p>Credentials</p>
          </Typography>
        </Typography>
        <Typography>
          <Typography
            onClick={() => handleMetricsClick(data)}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "5px",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <img src={metric_icon} width="30px" />
            <p>Metric</p>
          </Typography>
        </Typography>
        <Typography>
          <Typography
            onClick={() => handleAnalysisClick(data)}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "5px",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <img src={analysis_icon} width="30px" />
            <p>Analysis</p>
          </Typography>
        </Typography>
      </Grid>

      <Grid
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          marginTop: "15px",
        }}
      >
        <AntSwitch
          label={data.is_Active ? "Active" : "Inactive"}
          checked={data.is_Active}
          inputProps={{ "aria-label": "Account status" }}
        />
        <Typography
        className="dashboard-info-box-eyeIcon"
          sx={{
            borderRadius: "30px",
            // background: "var(--secondary-sb-50-background, #010101)",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "5px",
          }}
        >

          {theme === 'light-new'  ?
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.5851 9.79875C15.623 9.917 15.7063 10.0154 15.8166 10.0723C15.927 10.1293 16.0554 10.1401 16.1738 10.1025C16.4176 10.0238 16.5563 9.76125 16.4776 9.51375L16.4772 9.51263C16.4438 9.4125 14.5654 3.75 8.99968 3.75C3.43505 3.75 1.5563 9.4125 1.5233 9.513L1.52293 9.51375C1.44418 9.76125 1.57918 10.0238 1.82668 10.1025C2.07418 10.1813 2.33668 10.0462 2.41543 9.79875C2.48293 9.58875 4.10668 4.6875 9.00043 4.6875C13.8942 4.6875 15.5176 9.58875 15.5851 9.79875ZM9.00005 13.5C9.89516 13.5 10.7536 13.1444 11.3865 12.5115C12.0195 11.8785 12.3751 11.0201 12.3751 10.125C12.3751 9.22989 12.0195 8.37145 11.3865 7.73851C10.7536 7.10558 9.89516 6.75 9.00005 6.75C8.10495 6.75 7.2465 7.10558 6.61357 7.73851C5.98063 8.37145 5.62505 9.22989 5.62505 10.125C5.62505 11.0201 5.98063 11.8785 6.61357 12.5115C7.2465 13.1444 8.10495 13.5 9.00005 13.5Z" fill="#fff"/>
          </svg>
         :          
          <img src={open_eye} />
        }
          <img src={close_eye} />
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Account;
